export enum EmbedType {
  FIGMA = 'figma',
  MIRO = 'miro',
}
